import React, { useContext } from 'react'

export type ValueContextValue<Extra extends object = {}> = {
  value: string
  onChange: (value: string) => void
  layoutId: string
} & Extra

export const ValueContext = React.createContext<ValueContextValue>({
  onChange: () => {},
  value: '',
  layoutId: '',
})

export const useValueContext = () => {
  return useContext(ValueContext)
}
